import ActionButton from '../../components/ActionButton';
import Circle from '../../components/Circle';
import FaqList from '../../components/FaqList';
import Loader from '../../components/Loader';
import Page from '../../components/Page';
import PartnerBanks from '../../components/PartnerBanks';
import RrsHandler from '../../components/RrsHandler';
import Section from '../../components/Section';
import SectionTitle from '../../components/SectionTitle';
import Testimonials from '../../components/Testimonials';
import useBrainSession from '../../services/BrainSession/useBrainSession';
import { LANG } from '../../services/Config';

import { RRS_REFIN } from './RRS';
import HeaderSection from './_components/HeaderSection/HeaderSection';
import RefinancingArticle from './_components/RefinancingArticle/RefinancingArticle';
import data from './data.json';

const Refinancing = () => {
  const { appStrings } = LANG;
  const { isBobInit } = useBrainSession();

  if (!isBobInit) return <Loader />;

  return (
    <Page title={appStrings.PAGES.REFINANCING}>
      <RrsHandler {...RRS_REFIN} />
      <HeaderSection variant="a1" />
      {/*{showChatContainer ? null : <PageHeaderVariants />}*/}
      <Section background="contrast" fullWidth>
        <SectionTitle title={data?.testimonialsTitle || ''} color="contrast" />
        <Testimonials />
      </Section>
      <Section background="paper">
        <SectionTitle title={data?.banksTitle || ''} />
        <PartnerBanks
          variant="unicolored"
          data={data?.banksLinksToggle}
          isRefin
        />
      </Section>
      <RefinancingArticle />
      <Section>
        <FaqList category="Refinansiering" />
      </Section>
      <Section extraPadding background="paper">
        <Circle position="topLeft" color="default" />
        <Circle position="bottomRight" color="default" />
        <SectionTitle
          title={data?.profitTitle || ''}
          subtitle={data?.profitDesc || ''}
        />
        <ActionButton
          label={data.profitButton}
          flow="debt_check"
          step="skip_start_from_refinansiering"
          color="secondary"
        />
      </Section>
    </Page>
  );
};

export default Refinancing;
